import * as React from 'react';
import { SingleKeyValueComponent } from '../common/types';
import { SelectType, SelectCommonProps } from '../common/select/types';
import { SelectBaseComponent } from '../common/select/select-base-component';

export interface SelectSingleHierarchyProps extends SingleKeyValueComponent<number>, SelectCommonProps {
  /**
   * It allows user to select node from min level of hierarchy codes.
   * Default is 0.
   */
  minLevel?: number;
  /**
   * It allows user to select only leaf in hierarchy codes.
   * Default is false.
   */
  leafNodeOnly?: boolean;
  /**
   * It shows the whole path from root in description of selected option.
   * Default is false.
   */
  descriptionAllLevels?: boolean;
  /**
   * Reset to previous selected value when the field is cleared.
   * Default is false.
   */
  resetPreviousValueWhenEmpty?: boolean;

  /**
   * Show spinner next to label. 
   * Default is false.
   */
  showSpinnerLabel?: boolean;

  enableMultilineValidation?: boolean;
}

export class SelectSingleHierarchy extends React.Component<SelectSingleHierarchyProps> {
  public render() {
    return <SelectBaseComponent
      {...this.props}
      selectType={SelectType.singleHierarchy}
      valueItems={!!this.props.valueItem ? [this.props.valueItem] : []}
    />;
  }
}
